import script from "./Table_Patient.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_Patient.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__